import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { BaseEmbed } from '@cc-shopping/ui/composites/BaseEmbed';
import { BASE_EMBEDS_URL } from '@cc-shopping/ui/composites/BaseEmbed/constants';
import { Box } from '@mui/material';
import type { StructuredContentDocument } from '../../hydration/types';
export type CalculatedFieldsFormProps = StructuredContentDocument<{
  id: string;
}>;
export function CalculatedFieldsForm(t0) {
  const $ = _c(4);
  const {
    props: t1
  } = t0;
  const {
    id
  } = t1;
  const src = `${BASE_EMBEDS_URL}/cff/?form_id=${id}&nwaMode=embed`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      boxShadow: "0 4px 8px 0 rgb(100 102 106 / 10%), 0 1px 4px 0 rgb(100 102 106 / 36%)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== id || $[2] !== src) {
    t3 = <Box sx={t2}><BaseEmbed id={id} src={src} title="Calculated Fields Form" deployableEnv={env.NEXT_PUBLIC_NW_URL} /></Box>;
    $[1] = id;
    $[2] = src;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}